var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmovestics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#1976D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0099 49.9894L38.1629 86.293L27.6915 71.3384L89.9675 27.7323L89.9954 27.6924L152.307 71.3232L141.835 86.2778L90.0099 49.9894ZM131.747 86.2611H109.939V142.337H131.747V86.2611ZM70.6847 113.675H48.8772V142.336H70.6847V113.675ZM101.215 103.706H79.4074V142.336H101.215V103.706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmovestics);
export default __webpack_public_path__ + "static/media/immovestics.9f5a25b1a308e251922e4d4e13d9417c.svg";
export { ForwardRef as ReactComponent };